"use client";

import { useState, createContext, useContext } from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

const SnackBarContext = createContext(null);
export const useSnackbar = () => {
  return useContext(SnackBarContext);
};

const SnackbarProvider = ({ children }) => {
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const showSnackbar = (severity, message) => {
    setSnackbarState((x) => ({ severity, message, open: true }));
  };
  const closeSnackbar = () => {
    setSnackbarState((x) => ({ ...x, open: false }));
  };
  return (
    <>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        open={snackbarState.open}
        onClose={closeSnackbar}
        autoHideDuration={3000}
      >
        <Alert
          onClose={closeSnackbar}
          severity={snackbarState.severity}
          sx={{
            maxWidth: "400px",
          }}
        >
          {snackbarState.message}
        </Alert>
      </Snackbar>

      <SnackBarContext.Provider value={showSnackbar}>
        {children}
      </SnackBarContext.Provider>
    </>
  );
};

export default SnackbarProvider;
